// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QqOutlinedSvg from "@fishx/icons-svg/es/asn/QqOutlined";
import FishxIcon from '../components/FishxIcon';

var QqOutlined = function QqOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: QqOutlinedSvg
  }));
};

QqOutlined.displayName = 'QqOutlined';
export default React.forwardRef(QqOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/QqOutlined.js
// module id = 3939
// module chunks = 0